import {countBy, find} from 'lodash';

import {NODE_STATUSES} from '../consts';

export const getWorstStatus = (statuses: (string | undefined)[]) => {
  const statusCounters = countBy(statuses);
  return find(NODE_STATUSES, (status) => statusCounters[status] > 0);
};
